import ClaimsEventsTypes from "@upclaim/prisma/seeds/claims_events_types.json"
import { ClaimEventType } from "@/interfaces/data-contracts";

export type EventType = ClaimEventType['type'];

const ClaimsEventsTypesByType = new Map(ClaimsEventsTypes.map(cet => [cet.type as EventType, cet]));

function claimEventTypesByType(type: EventType) {
  const claimType = ClaimsEventsTypesByType.get(type);
  if (!claimType) throw `Type error: No Event Type named "${type}"`
  return claimType;
}

export {
  claimEventTypesByType,
}
